import { get, post } from './fetcher';
import { API_ENDPOINTS } from '../config/api-config';

export const getFavoriteList = async () => {
  return get(API_ENDPOINTS.FAVORITES.LIST);
};

export const addFavorite = async (naverDanjiCode, ptpNo = null, groupId = null) => {
  return post(API_ENDPOINTS.FAVORITES.ADD, { naverDanjiCode, ptpNo, groupId });
};

export const removeFavorite = async (naverDanjiCode, ptpNo = null) => {
  return post(API_ENDPOINTS.FAVORITES.REMOVE, { naverDanjiCode, ptpNo });
};

export const getFavoriteGroups = async () => {
  return get(API_ENDPOINTS.FAVORITES.GROUPS);
};

export const addFavoriteGroup = async (groupName) => {
  return post(API_ENDPOINTS.FAVORITES.GROUP_ADD, { groupName });
};

export const updateFavoriteGroup = async (groupId, groupName) => {
  return post(API_ENDPOINTS.FAVORITES.GROUP_UPDATE, { groupId, groupName });
};

export const deleteFavoriteGroup = async (groupId, deleteMembers = false) => {
  return post(API_ENDPOINTS.FAVORITES.GROUP_DELETE, { groupId, deleteMembers });
};

export const moveFavoritesToGroup = async (targetGroupId, items) => {
  // items: [{ naverDanjiCode, ptpNo }, ...]
  return post(API_ENDPOINTS.FAVORITES.GROUP_MOVE, { targetGroupId, items });
};

export const getFavoriteGroupComplexes = async (groupId) => {
  return get(`${API_ENDPOINTS.FAVORITES.GROUP_COMPLEXES}/${groupId}/complexes`);
};

export const removeFavoriteFromGroup = async (groupId, naverDanjiCode, ptpNo) => {
  return post(API_ENDPOINTS.FAVORITES.GROUP_REMOVE, { groupId, naverDanjiCode, ptpNo });
};
